import {
    AccessService,
    CheckAccessStatusResponseType,
    CheckAuthorizationResponseType,
    LogoSchema,
    CheckAccessStatusRequest,
    CheckAuthorizationRequest,
} from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteAccessService {
    constructor() {
        this.accessService = new AccessService();
    }

    /**
     * Checks for user auth status
     *
     * @param {CheckAccessStatusRequest} request - data passed to request
     * @returns {Promise<CheckAccessStatusResponseType>} - Promise of checkAccessStatus
     */
    checkAccessStatus = async (request = { logoSchema: LogoSchema.Black }) => {
        return this.accessService.checkAccessStatus(request);
    };

    /**
     * Checks for Authorization
     *
     * @param {string} resourceGroup - app's resourceId (ie mtv, bet...)
     * @returns {Promise<boolean>} - Promise of AccessService.getAuthorizationMethod call
     */
    checkIsAuthorized = async (resourceGroup) => {
        return this.accessService.getAuthorizationMethod({
            resourceGroup,
        });
    };

    /**
     * Checks for Authorization
     *
     * @param {string} resourceGroup - app's resourceId (ie mtv, bet...)
     * @returns {Promise<boolean>} - Promise of AccessService.getAuthorizationMethod call
     */
    isUserAuthorized = async (resourceGroup) => {
        return this.accessService.isAuthorized({
            resourceGroup,
        });
    };

    /**
     * Retrieves auth method
     *
     * @param {CheckAuthorizationRequest} request - data passed to request
     * @param {string} request.logoSchema - color scheme of the provider logos
     * @returns {Promise<CheckAuthorizationResponseType>} - Promise of checkAccessStatus
     */
    getAuthorizationMethod = async (request = { logoSchema: LogoSchema.Black }) => {
        return this.accessService.getAuthorizationMethod(request);
    };
}
